/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An organization's id and name, for pickers such as the event invite form.
 * @export
 * @interface OrganizationSummary
 */
export interface OrganizationSummary {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSummary
     */
    id: string;
}

/**
 * Check if a given object implements the OrganizationSummary interface.
 */
export function instanceOfOrganizationSummary(value: object): value is OrganizationSummary {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrganizationSummaryFromJSON(json: any): OrganizationSummary {
    return OrganizationSummaryFromJSONTyped(json, false);
}

export function OrganizationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function OrganizationSummaryToJSON(json: any): OrganizationSummary {
    return OrganizationSummaryToJSONTyped(json, false);
}

export function OrganizationSummaryToJSONTyped(value?: OrganizationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
    };
}

